import template from './mapFilterForm.html';
import controller from './mapFilterForm.controller';
import './mapFilterForm.scss';

let mapFilterFormComponent = {
  restrict: 'E',
  bindings: {
    save: '&',
    storeFile: '&',
    filter: '=',
    validation: '<'
  },
  template,
  controller
};

export default mapFilterFormComponent;
